// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button';
    var searchInputMobile = '.search-input-group input[type="search"]';
    var searchCloseButtonMobile = '.drawer__close > button';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  /*
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }
*/
  
  /* start-boost-custom */
  /* #boost-113585: customize search results */
  InstantSearchApi.beforeCall = function(searchTerm) {
    var term = Utils.encodeURIParamValue(unescape(searchTerm || '').replace(/&#x27;/g, '').replace(/&#x26;/g, '').replace(/&#x2A;/gi, ''));
    Globals.instantSearchQueryParams.q = term;
  }
  
  var searchSubmit = SearchInput.prototype._onSubmit;
  
  SearchInput.prototype._onSubmit = function(event, redirect) {
    searchSubmit.call(this, event, redirect);
    
    var term = unescape(Globals.currentTerm || '').replace(/&#x27;/g, '').replace(/&#x26;/g, '').replace(/&#x2A;/gi, '');
    var isApiReturnedResult = Globals.suggestionCache.hasOwnProperty(term);
    
    var redirectUrl = InstantSearchResultRedirect.getSearchRedirectUrl();
    
    if (isApiReturnedResult) {
      if (redirectUrl && !Utils.isBadUrl(redirectUrl)) {
        Utils.setWindowLocation(redirectUrl);
      } else {
        this.isChangePage = true;
        this.$searchForm[0].submit();
      }
    } 
  }
  /* end-boost-custom */
})();